// eslint-disable-next-line no-unused-vars
let utils;

export default utils = {
  verify: ((response) => {
    switch (response.length) {
      case 1:
        return response[0];
      case 0:
        return null;
      default:
        return response;
    }
  }),
  reassign: ((object, param, value) => {
    const newObj = object;
    newObj[param] = value;
    return newObj;
  }),
  storage: ((key) => {
    if (sessionStorage[key] !== undefined) {
      return JSON.parse(sessionStorage[key]);
    }
    return null;
  }),
  range: ((value, start, end) => ((value - start) * (value - end) <= 0)),
  type: ((value) => {
    if (value.length !== undefined) {
      return 'array';
    }
    if (Object.prototype.hasOwnProperty.call(value, 'id')) {
      return 'object';
    }
    if (value === null) {
      return 'null';
    }
    return 'error';
  }),
};
